export default __webpack_public_path__ + "static/denejniy-potok-dlia-detey-cfcc993fa75dadaf7c15bcbdb585db52.png";